module.exports = __webpack_public_path__ + "static/2-8f4e6b86f7597b7e0c79d1e5c5402647.png";